import React, {useEffect, useState} from 'react';
import {useAuth} from '@common/auth/use-auth';
import {IconButton} from '@common/ui/buttons/icon-button';
import {ContentCopyIcon} from '@common/icons/material/ContentCopy';
import { toast } from '@ui/toast/toast';
import { message } from '@ui/i18n/message';

interface AffiliateStats {
  totalReferrals: number;
  totalSubscribers: number;
  walletBalance: number;
  refCode: string;
}

const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '24px 0px 75px',
  },
  header: {
    marginBottom: '40px',
    textAlign: 'center' as const,
  },
  title: {
    fontSize: '24px',
    marginBottom: '10px',
    color: '#fff',
  },
  subtitle: {
    fontSize: '16px',
    color: '#999',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
    marginBottom: '40px',
  },
  card: {
   /* backgroundColor: '#2a2a2a', */
    borderRadius: '8px',
    padding: '20px',
  },
  cardTitle: {
    fontSize: '16px',
    color: '#999',
    marginBottom: '10px',
  },
  cardValue: {
    fontSize: '24px',
    
  },
  linkContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  linkText: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
    fontSize: '14px',
  },
  loading: {
    textAlign: 'center' as const,
    padding: '40px',
    color: '#999',
  },
  error: {
    textAlign: 'center' as const,
    padding: '40px',
    color: '#ff4444',
  }
};

export default function PageAfiliado() {
  const {user} = useAuth();
  const [stats, setStats] = useState<AffiliateStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    console.log('Current user:', user);
    if (!user?.id) return;
    fetchStats();
  }, [user?.id]);

  const fetchStats = async () => {
    try {
      setLoading(true);
      setError(null);
      
      console.log('Fetching stats for user:', user?.id);
      const response = await fetch(`/api/affiliate_stats.php?userId=${user?.id}`);
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch affiliate statistics');
      }
      
      const data = await response.json();
      console.log('Received data:', data);
      setStats(data);
      console.log('Stats after setting:', stats);
    } catch (err: any) {
      console.error('Full error:', err);
      setError(err.message || 'Failed to load statistics. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = () => {
    if (!stats?.refCode) return;
    
    const affiliateLink = `${window.location.origin}/register?ref=${stats.refCode}`;
    navigator.clipboard.writeText(affiliateLink).then(() => {
      //alert('Link copiado com sucesso!');
      toast.positive(message('Link copiado com sucesso!'));

    });
  };

  if (loading) {
    return <div style={styles.loading}>Carregando...</div>;
  }

  if (error) {
    return <div style={styles.error}>{error}</div>;
  }

  
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2>Programa de Afiliados</h2>
        <p style={styles.subtitle}>
          Compartilhe seu link e ganhe por cada novo assinante!
        </p>
      </div>

      <div style={styles.grid}>
        <div style={styles.card} className="bg-alt" >
          <h3 style={styles.cardTitle}>Total de Indicados</h3>
          <p style={styles.cardValue}>{stats?.totalReferrals || 0}</p>
        </div>

        <div style={styles.card} className="bg-alt">
          <h3 style={styles.cardTitle}>Assinantes Ativos</h3>
          <p style={styles.cardValue}>{stats?.totalSubscribers || 0}</p>
        </div>

        <div style={styles.card} className="bg-alt">
            <h3 style={styles.cardTitle}>Saldo da Carteira</h3>
            <p style={styles.cardValue}>
              {stats?.walletBalance 
                ? ((stats.walletBalance / 10000) < 1
                    ? (stats.walletBalance / 10000).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                        minimumFractionDigits: 4,
                        maximumFractionDigits: 4,
                      })
                    : (stats.walletBalance / 10000).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }))
                : 'R$ 0,0000'}
            </p>
          </div>

        <div style={styles.card} className="bg-alt">
          <h3 style={styles.cardTitle}>Seu Link de Afiliado</h3>
          <div style={styles.linkContainer}>
            <span style={styles.linkText}>
              {stats?.refCode ? 
                `${window.location.origin}/register?ref=${stats.refCode}` : 
                'Carregando...'}
            </span>
            <IconButton size="sm" onClick={copyToClipboard}>
              <ContentCopyIcon />
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  );
}
